import { createFileRoute } from '@tanstack/react-router';
import { QueuesPage } from '../../features/settings/components/queues-page.js';

export const Route = createFileRoute('/admin/queues')({ component: QueuesPage });
